import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

export interface StatusConfig {
    label: string;
    icon: React.ElementType;
    pulse: boolean;
    iconColor: string;
    textColor: string;
}

interface CallStatusProps {
    statusConfig: StatusConfig | null;
    isVisible: boolean;
    networkQuality: string | null;
}

export const CallStatus: React.FC<CallStatusProps> = ({ statusConfig, isVisible, networkQuality }) => (
    <div className={cn(
        "flex flex-col items-center gap-1 py-2 min-h-[2.75rem]",
        !isVisible && "invisible",
        isVisible && statusConfig?.pulse && "animate-pulse",
    )}>
        {isVisible && statusConfig && (
            <>
                <div className="flex items-center gap-2">
                    <statusConfig.icon className={cn("w-4 h-4", statusConfig.iconColor)} />
                    <span className={cn("font-medium", statusConfig.textColor)}>
                        {statusConfig.label}
                    </span>
                </div>
                {networkQuality && networkQuality !== 'good' && (
                    <Badge
                        variant="outline"
                        className={cn(
                            "text-xs",
                            networkQuality === 'poor'
                                ? "text-red-600 border-red-300 bg-red-50"
                                : "text-amber-600 border-amber-300 bg-amber-50"
                        )}
                    >
                        <div className={cn(
                            "rounded-full w-1.5 h-1.5 mr-1.5",
                            networkQuality === 'poor' ? "bg-red-500" : "bg-amber-500"
                        )} />
                        {networkQuality === 'poor' ? 'Poor network' : 'Degraded network'}
                    </Badge>
                )}
            </>
        )}
    </div>
);
